import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { NAV_ROUTES } from '../../utils/constants';

const Footer = () => {
  const { t } = useLanguage();
  const leftLinks  = NAV_ROUTES.slice(0, 5);
  const rightLinks = NAV_ROUTES.slice(5);

  return (
    <footer className="cf-footer">
      <div className="container">
        <div className="row g-4">

          {/* Brand column */}
          <div className="col-lg-4">
            <div className="footer-brand-name mb-1">चैत्राली फाउंडेशन</div>
            <p className="footer-tagline mb-3">{t('footer.tagline')}</p>
            <p className="footer-info-text mb-3">{t('about.missionText')}</p>
            <div className="d-flex gap-2 flex-wrap">
              {['facebook','instagram','youtube','twitter-x','whatsapp'].map(icon => (
                <a
                  key={icon}
                  href="https://www.chaitraleefoundationpune.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social"
                  aria-label={icon}
                >
                  <i className={`bi bi-${icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links column 1 */}
          <div className="col-6 col-lg-2 offset-lg-1">
            <div className="footer-section-title">{t('footer.quickLinks')}</div>
            {leftLinks.map(({ key, path }) => (
              <NavLink key={key} to={path} className="footer-link">{t(key)}</NavLink>
            ))}
          </div>

          {/* Links column 2 */}
          <div className="col-6 col-lg-2">
            <div className="footer-section-title">&nbsp;</div>
            {rightLinks.map(({ key, path }) => (
              <NavLink key={key} to={path} className="footer-link">{t(key)}</NavLink>
            ))}
          </div>

          {/* Contact column */}
          <div className="col-lg-3">
            <div className="footer-section-title">{t('footer.connect')}</div>
            <p className="footer-info-text mb-2">
              <i className="bi bi-geo-alt me-2" style={{color:'var(--footer-link)'}}></i>
              {t('contact.address')}
            </p>
            <p className="footer-info-text mb-2">
              <i className="bi bi-globe2 me-2" style={{color:'var(--footer-link)'}}></i>
              {t('contact.website')}
            </p>
            {/* QR hint */}
            <div className="mt-3 p-2 rounded-3 text-center border border-secondary border-opacity-25 d-inline-block">
              <i className="bi bi-qr-code" style={{fontSize:'2.5rem',color:'rgba(255,255,255,0.35)',display:'block',marginBottom:'4px'}}></i>
              <span style={{fontSize:'0.65rem',opacity:0.4,fontFamily:'Hind,sans-serif'}}>Scan QR Code</span>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="footer-copy">{t('footer.copyright')}</p>
          <p className="footer-copy fst-italic">{t('footer.builtWith')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
